import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik as FormikBase, Field } from "formik";
import { Navigate, Link } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import { emailMDInputFormik } from "@/helpers/formInputs";
import { isLoggedInSelector } from "@/features/auth/store/authSlice";
import {
  forgotPasswordThunk,
  resetState,
  isEmailSendSuccessfullySelector,
  isLoadingSelector,
} from "@/features/auth/store/resetPasswordSlice";
import { validateEmail } from "@/helpers/validations";
import MESSAGE from "@/helpers/messages";
import LoadingButton from "@/components/loaders/LoadingButton";
import LeftView from "@/features/auth/components/LeftView";
import MainSEO from "@/components/seo/MainSEO";
import { getDashboardPath } from "@/helpers/utils";

const Formik = FormikBase as unknown as React.ComponentType<any>;

const ForgotPassword = () => {
  const dispatch = useDispatch() as any;
  const isLoggedIn = useSelector(isLoggedInSelector);
  const isEmailSend = useSelector(isEmailSendSuccessfullySelector);
  const isLoading = useSelector(isLoadingSelector);
  /**
   * @method onSubmitForm
   * @description handle on submit form
   * @param {*} values
   */
  const onSubmitForm = (values: any, { setSubmitting }: any) => {
    dispatch(forgotPasswordThunk(values));
    setSubmitting(false);
  };

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // redirect to home when already logged in
  if (isLoggedIn) {
    return <Navigate to={getDashboardPath()} replace />;
  }

  return (
    <div className="row login-page">
      <MainSEO title="Forgot Password" url="forgot-password" />
      <div className="col-lg-6 p-0 d-none d-lg-block">
        <LeftView />
      </div>
      <div className="col-lg-6 d-flex flex-column justify-content-center px-lg-5 py-5">
        <div className="login-form">
          {isEmailSend ? (
            <>
              <h4 className="heading8 text-center">{MESSAGE.emailSend}</h4>
              <div className="d-flex justify-content-center my-4">
                <Button
                  component={Link}
                  variant="contained"
                  color="primary"
                  className="px-5"
                  to={"/"}
                >
                  {" "}
                  Log In{" "}
                </Button>
              </div>
            </>
          ) : (
            <>
              <Typography
                component="h2"
                variant="h4"
                className="fs-39"
                gutterBottom
              >
                Forgot Password
              </Typography>
              <Formik
                initialValues={{ email: "" }}
                onSubmit={onSubmitForm}
                validate={validateEmail}
              >
                {({ handleSubmit }: any) => {
                  return (
                    <form onSubmit={handleSubmit} className="mt-4 mt-md-5">
                      <Field
                        name="email"
                        label="E-Mail"
                        component={emailMDInputFormik}
                      />
                      <div className="row justify-content-center justify-content-sm-end">
                        <div className="col-sm-3 col-md-4 col-xl-2 mb-4 mb-sm-0">
                          <Button
                            component={Link}
                            to={"/"}
                            variant="outlined"
                            color="primary"
                            disabled={isLoading}
                            size="large"
                            fullWidth
                          >
                            Back
                          </Button>
                        </div>
                        <div className="col-sm-6 col-xl-5">
                          <LoadingButton
                            type="submit"
                            text="Send instructions"
                            isLoading={isLoading}
                            fullWidth
                          />
                        </div>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
